import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from '@services/config.service';
import { UserService } from '@services/user.service';
import { Subscription, timer } from 'rxjs';
import { IdleService } from 'src/app/shared/idle.service';
import { WebErrorService } from '@services/webError.service';
import { ExamineeloginService } from '@services/examineelogin.service';
import { DeliveryService } from '@services/delivery.service';
import { ActivatedRoute, Router } from '@angular/router';
import { counterTime } from '@configs/questions.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-two-factor-authentication-d',
  templateUrl: './two-factor-authentication-d.component.html',
  styleUrls: ['./two-factor-authentication-d.component.scss']
})

export class TwoFactorAuthenticationDComponent implements OnInit {
  fullyear = new Date().getFullYear();
  twoFactorAuth: FormGroup;
  submitted = false;
  collectionData$: Subscription | undefined;
  loginErrorMessage: string;
  userServiceSubscription$: Subscription;
  testbankuuId: any;
  testDetails: any;
  schId: any;
  isDisplayError: boolean = false;
  resendAuthenticationCode$: Subscription;
  countDown: Subscription;
  counter = counterTime.counter;
  isEnable: boolean = true;
  isValid: boolean = false;
  userData: any;
  constructor(public configService: ConfigService,
    public fb: FormBuilder, public UserService: UserService,
    public idleService: IdleService,
    private webErrorService: WebErrorService,
    private examineeloginservice: ExamineeloginService,
    private deliveryService: DeliveryService,
    private routerstate: ActivatedRoute,
    public translate: TranslateService,
    private router: Router) { }

  ngOnInit(): void {
    this.countDownFun();

    this.routerstate.paramMap.subscribe(data => {
      this.schId = data.get('id');
    });

    this.twoFactorAuth = this.fb.group({
      code : ['', [
        Validators.required,
        Validators.maxLength(6),
        Validators.pattern('^[0-9]*$')
      ]],
    });

    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  get f() { return this.twoFactorAuth.controls; }

  countDownFun() {
    this.countDown = timer(0, 1000).subscribe(() => {
      --this.counter
      if (this.counter === 0) {
        this.isEnable = false;
        this.countDown.unsubscribe();
      }
    });
  }

  signIn() {
    this.submitted = true;

    if (this.twoFactorAuth.valid) {
      this.isValid = true;

      let authCodePayload = {
        "emailId": this.userData.email,
        "authorizationCode": this.twoFactorAuth.value.code
      }

      this.examineeloginservice.verfiyAuthCode(authCodePayload).subscribe(data => {
        if (data.status == true) {
          if (this.userData.isTempPassword == true || localStorage.getItem('resetPassword') == 'true') {
            this.router.navigate(['/change-Passwordd']);
          } else {
            let payload = {
              "emailId": this.userData.email,
              "password": this.userData.password,
              // "authorizationCode": this.twoFactorAuth.value.code,
              "testscheduleuuid": this.schId
            }

            this.userServiceSubscription$ = this.examineeloginservice.signIn(payload).subscribe((data) => {
              if (data.status != false) {
                this.deliveryService.getExamineeTest(this.schId).subscribe(resData => {
                  this.testDetails = resData;
                  this.testbankuuId = this.testDetails?.testbankuuId;
                  this.router.navigate(['/delivery/start/test', this.testbankuuId]);
                }, (error: any) => {
                  this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                });
              } else {
                this.isValid = false;
                this.isDisplayError = false;
                this.loginErrorMessage = data.message;
              }
            }, (error: any) => {
              this.isValid = false;
              this.isDisplayError = false;
              this.loginErrorMessage = error.error.message;
            });

          }
        }
      });
    }
  }

  resendAuthenticationCode() {
    let payload = {
      "emailId": this.userData.email,
      "password": this.userData.password
    }

    this.resendAuthenticationCode$= this.examineeloginservice.resendAuthenticationCode(payload).subscribe(data =>{
      if (data.status != 'true') {
        this.isDisplayError = false;
        this.loginErrorMessage = data.message;
      } else  {
        this.isEnable = true;
        this.counter = counterTime.counter;
        this.countDownFun();
      }
    });
  }
}
